

(function () {
  'use strict';

  
  if (window.__veeryWishlistReady) return;
  window.__veeryWishlistReady = true;

  
  
  
  var STORAGE_KEY = 'veery_wishlist';
  var IMG_KEY = 'veery_wishlist_img';
  var memoryStore = null; 

  
  function storageAvailable() {
    try {
      var k = '__veery_test__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }
  var useLocalStorage = storageAvailable();

  
  function readStore() {
    if (!useLocalStorage) {
      return memoryStore ? memoryStore.slice() : [];
    }
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Object.prototype.toString.call(parsed) === '[object Array]' ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  
  function writeStore(arr) {
    if (!useLocalStorage) {
      memoryStore = arr.slice();
      return;
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      
      memoryStore = arr.slice();
    }
  }

  
  
  
  var handles = readStore();          
  var subscribers = [];               
  var productCache = {};
  var productPendiente = {};
  var productFallo = {};              

  
  function emitChange() {
    var snapshot = handles.slice();
    for (var i = 0; i < subscribers.length; i++) {
      try { subscribers[i](snapshot); } catch (e) {}
    }
    try {
      document.dispatchEvent(new CustomEvent('veery:wishlist:change', {
        detail: { handles: snapshot, count: snapshot.length }
      }));
    } catch (e) {
      
      var ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('veery:wishlist:change', true, false, {
        handles: snapshot, count: snapshot.length
      });
      document.dispatchEvent(ev);
    }
  }

  
  function indexOf(handle) {
    for (var i = 0; i < handles.length; i++) {
      if (handles[i] === handle) return i;
    }
    return -1;
  }

  
  
  
  function leerImagenes() {
    if (!useLocalStorage) return {};
    try {
      var raw = window.localStorage.getItem(IMG_KEY);
      var m = raw ? JSON.parse(raw) : null;
      return m && typeof m === 'object' && !(m instanceof Array) ? m : {};
    } catch (e) {
      return {};
    }
  }

  function escribirImagenes(mapa) {
    if (!useLocalStorage) return;
    var podado = {};
    for (var i = 0; i < handles.length; i++) {
      if (mapa[handles[i]]) podado[handles[i]] = mapa[handles[i]];
    }
    try {
      window.localStorage.setItem(IMG_KEY, JSON.stringify(podado));
    } catch (e) {}
  }

  function urlLimpia(u) {
    if (!u) return '';
    var s = String(u);
    if (s.indexOf('//') === 0) s = 'https:' + s;
    var base = s.split('?')[0];
    if (base.indexOf('/cdn/shop/') === -1 && base.indexOf('cdn.shopify.com') === -1) return '';
    return s;
  }

  function anchoMiniatura() {
    var dpr = window.devicePixelRatio || 1;
    return 88 * dpr <= 200 ? 200 : 400;
  }

  function conAncho(url, w) {
    if (!url) return '';
    var partes = url.split('?');
    var consulta = partes[1] || '';
    var yaTiene = consulta.match(/(?:^|&)width=(\d+)/);
    if (yaTiene && Number(yaTiene[1]) >= w) return url;
    var version = consulta.match(/(?:^|&)(v=[^&]+)/);
    return partes[0] + '?' + (version ? version[1] + '&' : '') + 'width=' + w;
  }

  function precalentarMiniatura(url) {
    var con = conAncho(url, anchoMiniatura());
    if (!con) return;
    try {
      var im = new Image();
      im.decoding = 'async';
      im.src = con;
    } catch (e) {}
  }

  function olvidarImagen(handle) {
    var mapa = leerImagenes();
    if (!mapa[handle]) return;
    delete mapa[handle];
    escribirImagenes(mapa);
  }

  var API = {
    getAll: function () {
      return handles.slice();
    },

    has: function (handle) {
      return indexOf(handle) !== -1;
    },

    count: function () {
      return handles.length;
    },

    add: function (handle) {
      if (!handle || this.has(handle)) return;
      handles.push(handle);
      writeStore(handles);
      emitChange();
    },

    
    insertAt: function (handle, index) {
      if (!handle || this.has(handle)) return;
      var i = typeof index === 'number' && index >= 0 && index <= handles.length ? index : handles.length;
      handles.splice(i, 0, handle);
      writeStore(handles);
      emitChange();
    },

    remove: function (handle) {
      var i = indexOf(handle);
      if (i === -1) return;
      handles.splice(i, 1);
      writeStore(handles);
      olvidarImagen(handle);
      emitChange();
    },

    
    toggle: function (handle) {
      if (!handle) return false;
      if (this.has(handle)) {
        this.remove(handle);
        return false;
      }
      this.add(handle);
      return true;
    },

    clear: function () {
      handles = [];
      writeStore(handles);
      emitChange();
    },

    
    subscribe: function (fn) {
      if (typeof fn !== 'function') return function () {};
      subscribers.push(fn);
      return function () {
        for (var i = 0; i < subscribers.length; i++) {
          if (subscribers[i] === fn) { subscribers.splice(i, 1); break; }
        }
      };
    },

    

    
    escapeHtml: function (str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },

    
    formatMoney: function (cents) {
      if (window.VeeryCarrito && window.VeeryCarrito.dinero) return window.VeeryCarrito.dinero(cents);
      return ((Math.round(Number(cents)) || 0) / 100).toFixed(2);
    },

    
    recordarImagen: function (handle, url) {
      var limpia = urlLimpia(url);
      if (!handle || !limpia) return;
      var mapa = leerImagenes();
      if (mapa[handle] === limpia) return;
      mapa[handle] = limpia;
      escribirImagenes(mapa);
    },

    imagenDe: function (handle) {
      return leerImagenes()[handle] || '';
    },

    anchoMiniatura: anchoMiniatura,

    urlMiniatura: function (handle) {
      return conAncho(leerImagenes()[handle] || '', anchoMiniatura());
    },

    fetchProduct: function (handle, forzar) {
      if (productCache[handle]) {
        return Promise.resolve(productCache[handle]);
      }
      if (productPendiente[handle]) return productPendiente[handle];
      var previo = productFallo[handle];
      if (!forzar && previo && Date.now() - previo.cuando < 30000) {
        return Promise.reject(previo.fallo);
      }
      var raizIdioma = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var peticion = fetch(raizIdioma + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) {
            var fallo = new Error(res.status === 404 ? 'not found' : 'HTTP ' + res.status);
            fallo.status = res.status;
            throw fallo;
          }
          return res.json();
        })
        .then(function (data) {
          delete productPendiente[handle];
          delete productFallo[handle];
          productCache[handle] = data;
          return data;
        }, function (fallo) {
          delete productPendiente[handle];
          productFallo[handle] = { fallo: fallo, cuando: Date.now() };
          throw fallo;
        });
      productPendiente[handle] = peticion;
      return peticion;
    },

    urlImagen: function (handle, w) {
      return conAncho(leerImagenes()[handle] || '', w);
    }
  };

  window.VeeryWishlist = API;

  
  
  
  
  
  
  
  
  
  function labelFor(btn, saved) {
    if (saved) {
      return btn.getAttribute('data-label-remove') || 'Remove from wishlist';
    }
    return btn.getAttribute('data-label-add') || 'Add to wishlist';
  }

  function pintarCorazon(btn, saved) {
    var valor = saved ? 'true' : 'false';
    if (btn.hasAttribute('data-guardado')) {
      btn.setAttribute('aria-label', labelFor(btn, saved));
      btn.setAttribute('data-guardado', valor);
      return;
    }
    btn.setAttribute('aria-pressed', valor);
    if (btn.hasAttribute('data-label-add')) btn.setAttribute('aria-label', labelFor(btn, saved));
  }

  function urlDeLaTarjeta(btn) {
    var delServidor = urlLimpia(btn.getAttribute('data-product-image'));
    if (delServidor) return delServidor;
    var nodo = btn.parentNode;
    for (var salto = 0; nodo && salto < 5; salto++) {
      if (nodo.querySelectorAll) {
        var imgs = nodo.querySelectorAll('img');
        for (var i = 0; i < imgs.length; i++) {
          var u = urlLimpia(imgs[i].currentSrc || imgs[i].src);
          if (u) return u;
        }
      }
      nodo = nodo.parentNode;
    }
    return '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-veery-wishlist]') : null;
    if (!btn) return;

    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    e.preventDefault();
    e.stopPropagation();

    var nowSaved = API.toggle(handle);

    if (nowSaved) {
      var deLaTarjeta = urlDeLaTarjeta(btn);
      API.recordarImagen(handle, deLaTarjeta);
      precalentarMiniatura(deLaTarjeta);
      API.fetchProduct(handle).catch(function () {});
    }

    
    pintarCorazon(btn, nowSaved);
    btn.classList.remove('is-animating');
    
    void btn.offsetWidth;
    btn.classList.add('is-animating');
  });

  
  
  
  
  function syncHearts() {
    var hearts = document.querySelectorAll('[data-veery-wishlist]');
    for (var i = 0; i < hearts.length; i++) {
      var h = hearts[i].getAttribute('data-product-handle');
      var saved = h ? API.has(h) : false;
      pintarCorazon(hearts[i], saved);
    }
  }

  
  function syncBadges() {
    var n = API.count();
    var badges = document.querySelectorAll('[data-veery-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n;
      if (n > 0) {
        badges[i].removeAttribute('data-empty');
      } else {
        badges[i].setAttribute('data-empty', 'true');
      }
      var boton = badges[i].closest ? badges[i].closest('[data-vwl-open]') : null;
      var base = boton && boton.getAttribute('data-vwl-nombre');
      if (base) {
        var nombre = n > 0 ? base + ' (' + n + ')' : base;
        if (boton.getAttribute('aria-label') !== nombre) boton.setAttribute('aria-label', nombre);
      }
    }
  }

  
  var handleWishlistChange = function () {
    syncHearts();
    syncBadges();
  };
  document.addEventListener('veery:wishlist:change', handleWishlistChange);

  
  var handleStorageChange = function (e) {
    if (e.key !== STORAGE_KEY) return;
    handles = readStore();
    emitChange();
  };
  if (useLocalStorage) {
    window.addEventListener('storage', handleStorageChange);
  }

  
  function bootstrap() {
    syncHearts();
    syncBadges();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  
  document.addEventListener('shopify:section:load', bootstrap);

  
  var badgesVigilados = typeof WeakSet === 'function' ? new WeakSet() : null;
  function restaurarSiPisado() {
    var n = API.count();
    if (n === 0) return;
    var badges = document.querySelectorAll('[data-veery-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      if (badges[i].hasAttribute('data-empty') || badges[i].textContent !== String(n)) {
        syncBadges();
        return;
      }
    }
  }
  function vigilarBadges() {
    if (!('MutationObserver' in window)) return;
    var badges = document.querySelectorAll('[data-veery-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (badgesVigilados && badgesVigilados.has(b)) continue;
      new MutationObserver(restaurarSiPisado).observe(b, {
        attributes: true, attributeFilter: ['data-empty'],
        childList: true, characterData: true, subtree: true
      });
      if (badgesVigilados) badgesVigilados.add(b);
    }
  }
  vigilarBadges();
  document.addEventListener('cart:update', function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        vigilarBadges();
        restaurarSiPisado();
      });
    });
  });
})();